import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { ApiUser } from "src/api/api_user";

/**
 * The properties for {@link ExternalUserTailscaleLogin}
 */
export type ExternalUserTailscaleLoginProps = {};

/**
 * Login page for external users
 */
export default function ExternalUserTailscaleLogin(props: ExternalUserTailscaleLoginProps) {
    const { token } = Route.useParams();
    const navigate = useNavigate();

    const completeTailscaleLogin = async () => {
        const res = await ApiUser.auth.authenticateTailscaleDevice(token);

        if (res.result === "Err") {
            if (res.error.access_expired) {
                await navigate({ to: "/u/tailscale-login/access-expired" });
            }
            if (res.error.access_planned) {
                await navigate({ to: "/u/tailscale-login/access-planned" });
            }
        }

        if (res.result === "Ok") {
            await navigate({ to: "/s/login/success" });
        }
    };

    useEffect(() => {
        completeTailscaleLogin().then();
    }, []);

    return;
}

export const Route = createFileRoute("/_user/u/tailscale-login/$token/")({
    component: ExternalUserTailscaleLogin,
});
